<template>
  <div>
    <h1>Workshop Traffic</h1>
    <hr>

    <!-- FILTER STARTS -->
    <flexibleFilter
      :dealer_type="'DEALER'"
      :fetch_filter="fetchFilter"
      @onFilter="setFilterUrl"
    ></flexibleFilter>
    <!-- FILTER ENDS -->

    <!-- Traffic Distribution Start -->
    <div class="innerBox mt-5">
      <h5 class="mb-2">Traffic Distribution</h5>
      <traffic-distribution
        :filterUrl="filterUrl"
      ></traffic-distribution>
    </div>
    <!-- Traffic Distribution End -->
  </div>
</template>

<script>
  import flexibleFilter from '@/components/filter/flexible_filter.vue'

  import trafficDistribution from './children/trafficDistribution'

  export default {
    data () {
      return {
        filterUrl : '',
        fetchFilter : 0,
      }
    },
    components : {
      flexibleFilter,
      trafficDistribution,
    },
    mounted () {
      this.fetchFilter++;
    },
    methods : {
      setFilterUrl(a){
        this.filterUrl = a
      }
    }
  }
</script>

<style scoped>
  
</style>